<template>
  <div :class="['toggle', { 'toggle--checked': isOn }, { 'toggle--disabled': disabled }]">
    <div :class="['toggle__slider', { 'toggle__slider--checked': isOn }]"></div>
    <label class="toggle__label">
      <input class="toggle__checkbox" type="checkbox" :checked="isOn"
        @input="emits('update:isOn', ($event.target as HTMLInputElement).checked)" />
      <span class="toggle__label-text"> on </span>
      <span class="toggle__label-text"> off </span>
    </label>
  </div>
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
  isOn: boolean
  disabled?: boolean
}>(), {
  disabled: false
})

const emits = defineEmits<{
  (event: 'update:isOn', isOn: boolean): void
}>()

</script>

<style lang="scss">
.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: $grey-80;
  border-radius: 12px;
  width: 50px;
  height: 24px;

  &--disabled {
    background-color: $grey-80;
    pointer-events: none;
    opacity: 20%;
  }

  &::before {
    content: '';
    position: absolute;
    border-radius: 13px;
    width: 52px;
    height: 26px;
    border: 1px solid transparent;
    transition: border-color 150ms $animationCurve;
  }

  &:hover::before {
    border-color: $white;
  }

  &--checked {
    background-color: $purple;

    &::before, &:hover::before {
      border: 1px solid transparent;
    }
  }

  &__slider {
    position: absolute;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background-color: $white;
    left: 2px;

    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;

    transition: all 150ms $animationCurve;

    &--checked {
      left: calc(100% - 2px - 20px);
    }
  }

  &__checkbox {
    display: none;
  }

  &__label {
    position: relative;
    display: flex;
    height: inherit;
    width: inherit;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;

    &-text {
      font-family: $font-regular;
      font-size: 12px;
      line-height: 12px;
      color: $white;
    }
  }
}
</style>
